import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FcpSummaryBarComponent } from './fcp-summary-bar.component';
import { FcpButtonModule } from '../fcp-button/fcp-button.module';
import { FcpIconModule } from '../fcp-icon';
import { FcpButtonSplitModule } from '../fcp-button-split/fcp-button-split.module';

@NgModule({
    declarations: [FcpSummaryBarComponent],
    imports: [CommonModule, FcpButtonModule, FcpIconModule, FcpButtonSplitModule],
    exports: [FcpSummaryBarComponent]
})
export class FcpSummaryBarModule {}
